export const reportError = e => {
  window.rg4js && window.rg4js('send', e)
}
